<template>
  <div class="box3">
    <div class="wrapper">
      <pageTitle
        title="站稳技术前沿<br/>鸿蒙测试赛道资源足"
        text="鸿蒙系统推广带动测试岗位需求增加，赛道资源充足、竞争压力更低。掌握其测试技术可站在开发前沿"
        titColor="#86909C"
      />
    </div>
    <div class="subject-box">
      <!-- <swiper :options="swiperOptionbox3" ref="mySwiper" class="swiperitems"> -->
        <div
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="box">
            <img :src="item.img" alt="" />
          </div>
        </div>
      <!-- </swiper> -->
      <!-- <div class="swiper-pagination-box3"></div> -->
    </div>
    <div class="wrapper">
      <p class="tip">截图来源：某直聘网于2024年12月6日发布的招聘需求</p>
      <!-- <a class="btn" @click="zixun('不同技能的软件测试薪资水平')"
        >不同技能的软件测试薪资水平</a
      > -->
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
// import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    // swiper,
    // swiperSlide,
  },
  methods: {
    zixun() {
      this.mai("软件测试-就业课","不同技能的软件测试薪资水平",0,null)
      this.clickZiXun()
    },
  },
  data() {
    return {
      list: [
        {
          img: require("../../../assets/coursePage/softwareTest/box3/01.png"),
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box3/02.png"),
        },
      ],

      cur: 0,
      swiperOptionbox3: {
        slidesPerView: "auto",
      },
    };
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  padding: 0 32px;
}
.tip {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #89ACD5;
  line-height: 34px;
  text-align: center;
}
.btn {
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 96px;
  text-align: center;
  width: 686px;
  height: 96px;
  background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);
  border-radius: 48px;
  display: block;
  margin-top: 48px;
}
.box3 {
  padding: 80px 0 88px;
  box-sizing: border-box;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box3/bg.png")
    no-repeat;
  background-size: cover;
  background-origin: center;

  .subject-box {
    margin: 48px auto 0;
    position: relative;

    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    border-radius: 20px;
    overflow: hidden;
  }

  .swiper-slide {
  }
  .swiper-slide:nth-child(2) {
    width: 674px;
  }
  .swiper-pagination-box3 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    transform: translate(-50%, 0px);
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }

  .swiperwrap {
    box-shadow: -8px 8px 42px 0px rgba(37,84,131,0.2);
    border-radius: 22px;
    width: 694px;
    margin: 0 auto;
    margin-bottom: 28px;
    .box {
      img {
        width: 100%;
        display: block;
      }
    }
  }
}
</style>
